import React from 'react'
import {AtlasButton} from '../../..'
import Toast from '../../../src/experimental/Toast/Toast'
import {
  StyledToastViewport,
  StyledToast,
  StyledToastTitle,
  StyledToastDescription,
  StyledToastAction
} from '../../../src/experimental/Toast/Styled'

const StyledToastExample = () => {
  const [open, setOpen] = React.useState(false)
  const eventDateRef = React.useRef(new Date())
  const timerRef = React.useRef(0)

  // eslint-disable-next-line no-unused-vars
  function oneWeekAway(date) {
    const now = new Date()
    const inOneWeek = now.setDate(now.getDate() + 7)
    return new Date(inOneWeek)
  }

  function prettyDate(date) {
    return new Intl.DateTimeFormat('en-US', {dateStyle: 'full', timeStyle: 'short'}).format(date)
  }

  React.useEffect(() => {
    return () => clearTimeout(timerRef.current)
  }, [])

  return (
    <>
      <Toast.Provider swipeDirection="right" duration={3000}>
        <AtlasButton
          onClick={() => {
            setOpen(false)
            window.clearTimeout(timerRef.current)
            timerRef.current = window.setTimeout(() => {
              eventDateRef.current = oneWeekAway()
              setOpen(true)
            }, 100)
          }}
        >
          Add to calendar
        </AtlasButton>

        <StyledToast open={open} onOpenChange={setOpen}>
          <StyledToastTitle>Scheduled: Catch up</StyledToastTitle>
          <StyledToastDescription asChild>
            <time dateTime={eventDateRef.current.toISOString()}>{prettyDate(eventDateRef.current)}</time>
          </StyledToastDescription>
          <StyledToastAction asChild altText="Goto schedule to undo">
            <AtlasButton
              spacing={'compact'}
              onClick={() => {
                setOpen(false)
              }}
            >
              Undo
            </AtlasButton>
          </StyledToastAction>
        </StyledToast>
        <StyledToastViewport />
      </Toast.Provider>
    </>
  )
}
export default StyledToastExample
